import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, Mail, Clock, Menu, X, Siren } from "lucide-react";
import Logo from "./Logo";

const LINKS = [
  { label: "Početna", href: "#pocetna" },
  { label: "Usluge", href: "#usluge" },
  { label: "Šlep Služba", href: "#slep-sluzba" },
  { label: "Proizvodi", href: "#proizvodi" },
  { label: "Recenzije", href: "#recenzije" },
  { label: "Kontakt", href: "#kontakt" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className="fixed top-0 inset-x-0 z-50">
      <div className="hidden md:flex items-center justify-between px-6 lg:px-12 py-2 bg-[#0c0c0f] border-b border-white/5 text-xs text-zinc-400">
        <div className="flex items-center gap-6">
          <a data-testid="topbar-phone-link" href="tel:0677775613" className="flex items-center gap-2 hover:text-white transition-colors">
            <Phone size={12} className="text-red-500" /> 0677775613
          </a>
          <a data-testid="topbar-email-link" href="mailto:autobayserbia@gmail.com" className="flex items-center gap-2 hover:text-white transition-colors">
            <Mail size={12} className="text-red-500" /> autobayserbia@gmail.com
          </a>
        </div>
        <div className="flex items-center gap-6">
          <span className="flex items-center gap-2">
            <Clock size={12} className="text-red-500" /> Servis: Pon - Sub 08:00 - 19:00
          </span>
          <span data-testid="topbar-emergency-badge" className="flex items-center gap-2 text-red-400 font-semibold tracking-wide">
            <Siren size={12} /> ŠLEP SLUŽBA 00-24h
          </span>
        </div>
      </div>

      <nav
        className={`flex items-center justify-between px-5 lg:px-12 py-3 transition-colors duration-300 border-b border-white/5 ${
          scrolled || open ? "bg-[rgba(9,9,11,0.9)] backdrop-blur-md" : "bg-[rgba(9,9,11,0.6)] backdrop-blur-sm"
        }`}
      >
        <a data-testid="navbar-logo" href="#pocetna" className="flex items-center gap-3">
          <Logo size={38} />
          <div className="leading-none">
            <span className="font-display text-2xl tracking-wider text-white">AUTO<span className="text-red-500">BAY</span></span>
            <span className="block text-[10px] tracking-[0.3em] text-zinc-500 uppercase">Servis & Šlep</span>
          </div>
        </a>

        <div className="hidden lg:flex items-center gap-7">
          {LINKS.map((l) => (
            <a
              key={l.href}
              data-testid={`navbar-link-${l.href.slice(1)}`}
              href={l.href}
              className="text-sm text-zinc-400 hover:text-white transition-colors font-medium"
            >
              {l.label}
            </a>
          ))}
          <a
            data-testid="navbar-login-link"
            href="/admin"
            className="text-sm text-zinc-400 hover:text-white transition-colors font-medium"
          >
            Prijava
          </a>
          <a
            data-testid="navbar-call-button"
            href="tel:0677775613"
            className="ml-2 flex items-center gap-2 bg-red-600 hover:bg-red-500 text-white text-sm font-semibold px-5 py-2.5 rounded-full transition-all hover:shadow-[0_0_24px_rgba(227,22,30,0.5)] active:scale-[0.97]"
          >
            <Phone size={15} /> Pozovi Odmah
          </a>
        </div>

        <button
          data-testid="navbar-mobile-toggle"
          onClick={() => setOpen(!open)}
          className="lg:hidden text-white p-2"
          aria-label="Meni"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </nav>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -12 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -12 }}
            transition={{ duration: 0.25 }}
            className="lg:hidden bg-[rgba(9,9,11,0.97)] backdrop-blur-md border-b border-white/10 px-6 py-6 flex flex-col gap-4"
          >
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-zinc-300 hover:text-white text-base font-medium transition-colors"
              >
                {l.label}
              </a>
            ))}
            <a
              href="tel:0677775613"
              className="mt-2 flex items-center justify-center gap-2 bg-red-600 text-white font-semibold px-5 py-3 rounded-full"
            >
              <Phone size={16} /> Pozovi Odmah
            </a>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
